import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import { RemediationTableManagement } from "./RemediationTableManagement"

import RemediationTable from "./RemediationTable";
import RemediationTableHeader from "./RemediationTableHeader";
import PaginationManager from "../../view/PaginationManager";
import * as remediationService from "./remediationService";


function RemediationTableSection() {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <RemediationTableManagement />
                            <RemediationTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <RemediationTable />
                                            <PaginationManager getPage={remediationService.listPageable} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default RemediationTableSection;
